import React from 'react'
import PropTypes from 'prop-types'
import './paragraph.scss'
const Paragraph = ({ variant, className, children, style }) => (
	<div
		style={style}
		className={`a__paragraph ${variant ? `a__${variant}` : 'a__text'} ${
			className ? className : ''
		}`}
	>
		{children}
	</div>
)

Paragraph.propTypes = {
	children: PropTypes.string.isRequired
}

export default Paragraph
